import React, { useImperativeHandle, forwardRef, useState, useEffect } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import {ApiGridSearch} from '@assets/js/api/commonApi.js';

const CompGridMatchDtl = forwardRef((props, ref) => {
    // Forward ref to allow parent components to call event functions.
    // This is useful for controlling the modal from outside this component.
    useImperativeHandle(ref, () => ({
        onGridSearch: (p_params) => {
            onGridSearch(p_params);
        },
    }));

    /**********************
     * Define Grid vaiable
     ***********************/
    // State for grid pagination and loading
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 100,
    });
    const [loading, setLoading] = useState(false);
    const [rows, setRows] = useState([]);
    const [totalRowCount, setTotalRowCount] = useState(0);
    const [rowSelectionModel, setRowSelectionModel] = useState({ type: 'include', ids: new Set() });

    // Define columns for DataGrid
    const columns = [
        { field: 'rowNum', headerName: 'No.', width: 65, headerAlign: 'center', align: 'center' },
        { field: 'comptnNm', headerName: '대회명', width: 200, headerAlign: 'center', align: 'left' },
        { field: 'dvsnNm', headerName: '부문', width: 150, headerAlign: 'center', align: 'center' },
        { field: 'wetclsNm', headerName: '체급', width: 150, headerAlign: 'center', align: 'center' },
        { field: 'armTypeNm', headerName: '팔 유형', width: 100, headerAlign: 'center', align: 'center' },
        { field: 'plyrCd', headerName: '선수코드', width: 150, headerAlign: 'center', align: 'center',
            renderCell: (params) => (
                <span style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }} onClick={() => handleRowClick(params)}>
                    {params.value}
                </span>
            )
        },
        { field: 'plyrNm', headerName: '선수명', width: 150, headerAlign: 'center', align: 'left' },
    ];

    /*********************
     * Define Grid events
     ***********************/
    const onGridSearch = (p_params) => {
        let params = {
            page: paginationModel.page,
            pageSize: paginationModel.pageSize,
            offset: paginationModel.page*paginationModel.pageSize,
            ...p_params
        }

        // <-- loading start
        setLoading(true);
        // Fetch data from the server
        ApiGridSearch('/sys/matchdtlmng/search/list', params)
        .then(res => {
            if (res.data.result) {
                const rows = res.data.dataList.length > 0 ? res.data.dataList : [];
                const totalCount = res.data.dataList.length > 0 ? res.data.dataList[0].totalCount : 0;
                setRows(rows);
                setTotalRowCount(totalCount);
            }

            setRowSelectionModel({ type: 'include', ids: new Set() });
        })
        .catch(error => {
            console.error('Error fetching match detail list:', error);
        })
        .finally(() => {
            // <-- loading end
            setLoading(false);
        });
    }

    // Pass selected row data to parent component
    const handleRowClick = (params) => {
        if (params.field === 'plyrCd') {
            props.onChildClick(params.row);
        }
    };

    /**********************
     * Define useEffect
     ***********************/
    useEffect(() => {
        onGridSearch();
        // eslint-disable-next-line
    }, [paginationModel]);

    return (
        <>
            <div className="grid-container">
                <h4>대진 선수 목록</h4>
            </div>
            <div className="grid-wrapper">
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={(row) => `${row.mngCd}|${row.mtmkgCd}|${row.armType}|${row.plyrCd}`}
                    loading={loading}
                    pageSizeOptions={[100, 200, 500]}
                    paginationModel={paginationModel}
                    onPaginationModelChange={setPaginationModel}
                    paginationMode="server"
                    rowCount={totalRowCount}
                    checkboxSelection
                    rowSelectionModel={rowSelectionModel}
                    onRowSelectionModelChange={(newSelection) => {
                        if (props.onSelectionChange) {
                            setRowSelectionModel(newSelection);
                            props.onSelectionChange(newSelection);
                        }
                    }}
                    keepNonExistentRowsSelected
                    />
            </div>
        </>
    );
});

export default CompGridMatchDtl;
